import { types } from 'mobx-state-tree';

import { BookingStore } from './booking';
import { isAuthenticated } from '../utils/auth';
import { WeatherStore } from './weather/weather';
import { initialState, PassolutionStore } from './passolution';
import { ContactStore } from './contacts';
import { DocumentStore } from './documents';
import { UpgradeStore } from './upgrades';

export const StoreModel = types
  .model('StoreModel', {
    BookingStore,
    ContactStore,
    UpgradeStore,
    DocumentStore,
    weather: WeatherStore,
    passolution: PassolutionStore,
  })
  .actions((self) => ({
    afterCreate() {
      if (isAuthenticated()) {
        self.BookingStore.booking.fetch();
      }
    },
  }));

export const Store = StoreModel.create({
  BookingStore: BookingStore.create({}),
  ContactStore: ContactStore.create({}),
  UpgradeStore: UpgradeStore.create({}),
  DocumentStore: DocumentStore.create({}),
  weather: {},
  passolution: PassolutionStore.create({
    ...initialState,
    options: {},
    selection: {},
    endpoints: {
      entryConditions: 'passolution/conditions',
      options: 'passolution/options',
    },
  }),
});
